<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-m_restock"></i>补货建议</div>

    <div class="page-content">
      <el-form style="font: bold" :inline="true" label-width="120px" size="small" :model="formInline">
        <!-- <el-form-item label="指定月份成本：">
          <el-date-picker v-model="formInline.pullDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%" type="date"> </el-date-picker>
        </el-form-item> -->
        <el-form-item label="店铺名称：">
          <el-select v-model="formInline.shopId" clearable filterable placeholder="请选择" @change="realChange">
            <el-option v-for="types in dataShops" :key="types.id" :value="types.id" v-text="types.shopName" :label="types.shopName" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-select v-model="formInline.remark" clearable placeholder="请选择">
            <!-- <el-option label="请选择" value /> -->
            <el-option v-for="types in remarkArr" :key="types.id" :value="types.name" v-text="types.name" :label="types.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="站点：">
          <el-select v-model="formInline.site" style="width: 100%" clearable placeholder="请选择">
            <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
          <el-button type="primary" @click="downLoadRestockFile" style="backgroundcolor: #2a3861; bordercolor: transparent">导出补货 </el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100vh - 1.35rem)"
        :data="tableData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        style="
            width: 96%;
            margin-top: 10px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="sku" label="SKU" width="250" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="shopName" label="门店名称" width="140" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="site" label="站点" width="100" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="amazonQuantityValid" label="FBA可售数量" width="120" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="amazonQuantityShipping" label="FBA在途数量" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="totalNumber" label="订单总数量" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="salesAvg7" label="日均销量-7天" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="salesAvg14" label="日均销量-14天" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="salesAvg30" label="日均销量-30天" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="everyAvgNum" label="日均销量" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="suggestNum" label="建议补货量" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="summaryRemark" label="备注" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="createTime" label="最后拉取时间" show-overflow-tooltip width="120" :formatter="formatTime"> </el-table-column>
        <!-- <el-table-column prop="hytc" label="头程单价" width="100" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="tcdpzcb" label="单品总头程" width="100" show-overflow-tooltip> </el-table-column> -->
      </el-table>
      <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    var user = window.sessionStorage["user"];
    return {
      dataShops: [],
      /*创建角色*/
      addRoleDialog: false,
      modelTitle: "",
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: "",
        description: "",
        authorityIds: [],
      },
      remarkArr: [
        {
          name: "需要优化",
          id: 0,
        }
      ],
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        pullDate: "",
        shopName: "",
        site: "",
      },
      pullDate: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      Fnupload: {
        id: "",
        businessType: "",
      },
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      dataSites: [],
      flagClick: false
    };
  },
  created() {
    this.getAllDicts();
  },
  methods: {
    getAllDicts() {
      /*获取所有店铺*/
      this.axios.get("/api/shop/list").then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
          this.getAllSites();
          this.getPreDate();
        }
      });
    },
    getAllSites() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key) {
            if (key.indexOf("1130") == 0) {
              // 站点
              let siteData = data[key];
              siteData.map((item) => {
                item.codeName = item.codeValue + "（" + item.codeName + "）";
              });

              this.dataSites = siteData;
              this.query(); /*绑定树*/
            }
          }
        }
      });
    },
    // 店铺名称下拉选择
    realChange(val) {
      if(!val){
        this.formInline.shopName = '';
      }else{
        let obj = this.dataShops.find(function(i) {
          return i.id === val;
        });
        this.formInline.shopName = obj.shopName;
      }

    },
    downLoadRestockFile() {
      let baseurl = this.axios.defaults.baseURL;
      let path = '/api/sku-info/export-restock?pullDate=' + this.getPreDate();
      if (this.formInline.shopName) {
        path += "&shopName=" + this.formInline.shopName;
      } 
      if (this.formInline.site) {
        path += "&site=" + this.formInline.site;
      }
      if (this.formInline.remark) {
        path += "&remark=" + this.formInline.remark;
      } 
      this.axios({
        url: path,
        method: 'get',
        responseType: 'blob',
      }).then(res => {
          console.log('res', res);
          this.downloadCallback(res, '补货列表.xlsx');
        }
      ).catch(err => {
        console.log(err.message);
      });
      // window.open(path, "_blank");
      // /*加个下载成功的进度条*/
      // setTimeout(() => {
      //   this.$message({
      //     message: "下载成功",
      //     type: "success",
      //     center: true,
      //   });
      // }, 2000);
    },
    downloadCallback(res, fileName) {
      var blob = new Blob([res.data], 
        {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'});
        var download = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        download.style.display = 'none';
        download.href = href;
        download.download =fileName ; //下载后文件名
        document.body.appendChild(download);
        download.click(); //点击下载
        document.body.removeChild(download); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      this.tableData = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.total = resp.data.data && resp.data.data.total ? resp.data.data.total : 0;
    },
    queryParams() {
      this.currentPage = 1;
      this.query();
    },
    getPreDate() {
      var cur = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      //var result = cur.getFullYear() + "-" + this.checkMonth(cur.getMonth()) + '-' + this.checkMonth(cur.getDate());
      return moment(cur).format("YYYY-MM-DD");
    },
    checkMonth(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      this.formInline.pullDate = this.getPreDate();
      // if (this.formInline.pulldate != null && this.formInline.pulldate != "" && this.formInline.pulldate != undefined) {
      //   o.pulldate = moment(this.formInline.pulldate).format("YYYY-MM-dd");
      // } else {
      //   delete o.pulldate;
      // }
      this.axios
        .get("/api/sku-info/page-restock", {
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    }
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 80px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #98dcc4;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form {
      width: 100%;
      height: 36px;
      line-height: 36px;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #e4653a;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}
</style>
